import {gsap} from 'gsap'



// ******************
// Selectors
// ******************
const body = document.querySelector('body')
const ctaButton = document.querySelector('.ctaButton')
const contactSection = document.querySelector('.contact')
const closeContactBtn = document.querySelector('.contact--close')
const form = document.querySelector('form')
const nextBtn = document.getElementById('nextBtn')
const prevBtn = document.getElementById('prevBtn')
const submitBtn = document.getElementById('submitBtn')
const inputContainer = document.querySelector('.contact--form__inputContainer')
const inputPortal = document.querySelector('.contact--form__inputPortal')
const errorContainer = document.querySelector('.contact--error')
const errorText = document.querySelector('.contact--error__text')



// ******************
// Contact Form
// ******************
let currentIndex = 0
const messages = [
  'Por favor díganos su nombre antes de seguir',
  'Por favor revise que su número de contacto sea correcto',
  'Necesitamos un correo para enviarle información'
]

function showContactForm() {
  body.style.overflow = 'hidden'
  const overlay = document.createElement('div')
  overlay.classList.add('contact--overlay')
  overlay.classList.add('contact--overlay_original')
  body.appendChild(overlay)
  const showFormAnimation = gsap.timeline()
  .to(contactSection, {x: '100%'})
  .from(overlay, {opacity: 0}, '<')
}


function closeContactForm() {
  body.style.overflow = 'auto'
  const overlay = document.querySelector('.contact--overlay')
  const inputs = form.querySelectorAll('input')
  const currentInput = document.querySelector(`[data-index="${currentIndex}"] input`)
  inputs.forEach((input) => {input.value = null})
  if(currentInput && currentInput.classList.contains('error')) {
    currentInput.classList.remove('error')
    gsap.to(errorContainer, {y: '0%', ease: 'power4.inOut'})
  }
  currentIndex = 0
  prevBtn.disabled = true
  prevBtn.classList.add('inactive')
  const closeAnimation = gsap.timeline({
    onComplete: () => {overlay.remove()}
  })
  .to(contactSection, {x: '0%', ease: 'power2.inOut'})
  .to(overlay, {opacity: 0}, '<')
  .to(inputContainer, {y: 0})
}


function emailIsValid (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}


function showNextInput(e) {
  e.preventDefault()
  const currentInput = document.querySelector(`[data-index="${currentIndex}"] input`)

  // Check if empty string
  if(currentInput.value.trim() == '' || currentInput.value == null) {
    currentInput.classList.add('error')
    errorText.innerText = messages[currentIndex]
    gsap.to(errorContainer, {y: '-100%', ease: 'power2.inOut'})
    return
  } 

  // Valid content
  if(currentInput.value.length > 0) {
    if(currentInput.classList.contains('error')) {
      currentInput.classList.remove('error')
      gsap.to(errorContainer, {y: '0%', ease: 'power4.inOut'})
    }

    if(currentIndex == 0) {
      prevBtn.classList.remove('inactive')
      prevBtn.disabled = false
    }

    if(currentIndex < 2) {
      const yAmount = ((currentIndex + 1) * -5)+'em'
      currentIndex += 1
      gsap.to(inputContainer, {y: yAmount})
    } 

    else if(currentIndex == 2) {
      const email = currentInput.value

      if(emailIsValid(email) == false) {
        currentInput.classList.add('error')
        errorText.innerText = 'Por favor revise su dirección de correo'
        gsap.to(errorContainer, {y: '-100%', ease: 'power2.inOut'})
        return
      }
      
      if(emailIsValid(email) == true) {
        currentInput.classList.remove('error')
        const yAmount = ((currentIndex + 1) * -5)+'em'
        currentIndex += 1
        gsap.to(inputContainer, {y: yAmount})
      }
      // form.submit()
    }

    if(currentIndex == 3) {
      nextBtn.classList.add('inactive')
      nextBtn.disabled = true
    }
    console.log('currentIndex: ', currentIndex)
  }
}

function showPrevInput(e) {
  e.preventDefault()
  const currentInput = document.querySelector(`[data-index="${currentIndex}"] input`)

  if(currentIndex > 0) {
    const yAmount = ((currentIndex - 1) * -5)+'em'
    currentIndex -= 1
    gsap.to(inputContainer, {y: yAmount})
  }

  if(currentIndex == 0) {
    prevBtn.disabled = true
    prevBtn.classList.add('inactive')
  }

  if(currentIndex < 3) {
    nextBtn.classList.remove('inactive')
    nextBtn.disabled = false
  }
}


async function submitForm(e) {
  e.preventDefault()
  const mailEndpoint = 'https://formsubmit.co/ajax/ventas@visualmedica.mx'
  const nombre = document.getElementById('nombre').value
  const telefono = document.getElementById('telefono').value
  const email = document.getElementById('email').value
  const producto = ctaButton.getAttribute('data-product')
  
  try {
    const res = await fetch(mailEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({nombre, telefono, email, producto}),
    })
    const data = await res.json()

  } catch (error) {
    console.error(error)
  }

  //Create overlay
  const overlay = document.querySelector('.contact--overlay_original')
  const finalOverlay = document.createElement('div')
  finalOverlay.classList.add('contact--overlay')
  finalOverlay.classList.add('contact--overlay_final')
  const messageContainer = document.createElement('div')
  messageContainer.classList.add('contact--overlay__messageContainer')
  const messageText = document.createElement('p')
  messageText.classList.add('contact--overlay__text')
  messageText.innerText = '¡Gracias! Pronto nos pondremos en contacto.'
  
  body.appendChild(finalOverlay)
  finalOverlay.appendChild(messageContainer)
  messageContainer.appendChild(messageText)

  function clearForm() {
    body.style.overflow = 'auto'
    const inputs = form.querySelectorAll('input')
    inputs.forEach((input) => {input.value = null})
    currentIndex = 0
    prevBtn.disabled = true
    prevBtn.classList.add('inactive')
    overlay.remove()
    finalOverlay.remove()
  }

  const submitAnimation = gsap.timeline({
    onComplete: clearForm,
  })
  .from(finalOverlay, {opacity: 0})
  .from(messageContainer, {y: 30, opacity: 0}, '-=.3')
  .to(overlay, {duration: 3})
  .to(contactSection, {x: '0%', ease: 'power2.inOut'})
  .to(finalOverlay, {opacity: 0}, '<')
  .to(inputContainer, {y: 0, duration: 0.1})

}


ctaButton.addEventListener('click', showContactForm)
closeContactBtn.addEventListener('click', closeContactForm)
nextBtn.addEventListener('click', (e) => {showNextInput(e)})
prevBtn.addEventListener('click', (e) => {showPrevInput(e)})
submitBtn.addEventListener('click', (e) => {submitForm(e)})

form.addEventListener('keypress', (e) => {if(e.key == 'Enter') {e.preventDefault()}})
